import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/global.css';
import voice_sns from '../../assets/images/work/voice_sns/thumbnail.png';
import raiden from '../../assets/images/work/raiden/raiden_thumbnail.png';
import torus from '../../assets/images/work/torus/thumbnail.png';
import banner from '../../assets/images/work/banner/thumbnail.jpg';
import ablab from '../../assets/images/work/ablab/thumbnail.jpg';

function WorksTest() {

    const works = [
      {
        id: 1,
        link: "/voice_sns", 
        thumbnail: voice_sns, 
        title: "音声SNSアプリ", 
        tags: ["モバイルUI", "BONO課題"] 
      },
      {
        id: 2,
        link: "/raiden", 
        thumbnail: raiden, 
        title: "酒彩bar「RAIDEN」様 新規サイト提案", 
        tags: ["webデザイン", "worepress","コーディング", "デジハリ卒制"] 
      },
      {
        id: 3,
        link: "/torus",
        thumbnail: torus,
        title: "ドーナツ専門店「TORUS」サイト", 
        tags: ["webデザイン", "コーディング","架空サイト", "自主制作"]
      },
      {
        id: 4,
        link: "/banner",
        thumbnail: banner,
        title: "バナー集", 
        tags: ["バナー", "自主制作"]
      },
      {
        id: 5,
        link: "/ablab",
        thumbnail: ablab,
        title: "あなたを宇宙に巻き込む名刺", 
        tags: ["グラフィック", "名刺","実案件"]
      }
    ];
  
    return (
      <section id="works">
        <h1 className="section-title">WORKS</h1>
        <div className="works-content">
          {works.map((work) => (
            <Link key={work.id} to={work.link} className="work-link">
              <div className="work-item">
                {/* サムネイル */}
                <div className="work-thumbnail">
                  <img src={work.thumbnail} alt={work.title} />
                </div>
                {/* タイトル */}
                <div className="work-title">
                  <h3>{work.title}</h3>
                </div>
                {/* タグ一覧 */}
                {work.tags && work.tags.length > 0 && (
                  <ul className="wrapper-tag">
                    {work.tags.map((tag, index) => (
                      <li key={index} className="work-tag tag">
                        #{tag}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Link>
          ))}
        </div>
      </section>
    );
  }
  
  export default WorksTest;